import { apiClient } from '../client';

export interface UserPreferences {
  favoriteBarIds: string[];
  hiddenBarIds: string[];
  updatedAt: string | null;
}

export interface PreferencesResponse {
  success: boolean;
  preferences: UserPreferences;
}

export const preferencesApi = {
  /**
   * Get current user's preferences
   */
  get: async (): Promise<PreferencesResponse> => {
    const { data } = await apiClient.get<PreferencesResponse>('/v1/preferences');
    return data;
  },

  /**
   * Sync local preferences with server (merge on login)
   */
  sync: async (local: {
    favoriteBarIds: string[];
    hiddenBarIds: string[];
  }): Promise<PreferencesResponse> => {
    const { data } = await apiClient.post<PreferencesResponse>('/v1/preferences/sync', local);
    return data;
  },

  /**
   * Add a bar to favorites
   */
  addFavorite: async (barId: string): Promise<PreferencesResponse> => {
    const { data } = await apiClient.post<PreferencesResponse>(`/v1/preferences/favorites/${barId}`);
    return data;
  },

  /**
   * Remove a bar from favorites
   */
  removeFavorite: async (barId: string): Promise<PreferencesResponse> => {
    const { data } = await apiClient.delete<PreferencesResponse>(`/v1/preferences/favorites/${barId}`);
    return data;
  },

  /**
   * Add a bar to hidden list
   */
  addHidden: async (barId: string): Promise<PreferencesResponse> => {
    const { data } = await apiClient.post<PreferencesResponse>(`/v1/preferences/hidden/${barId}`);
    return data;
  },

  /**
   * Remove a bar from hidden list
   */
  removeHidden: async (barId: string): Promise<PreferencesResponse> => {
    const { data } = await apiClient.delete<PreferencesResponse>(`/v1/preferences/hidden/${barId}`);
    return data;
  },
};
